import "./award-item.sass";

type Props = {
  img?: string;
  title: string;
  text: string;
  link?: string;
  awardTitle?: string;
};

const AwardItem = ({ img, text, title, link, awardTitle }: Props) => {
  return (
    <a href={link} target="_blank" rel="noreferrer" className="award-item">
      <div className="award-item__upper">
        <div className="award-item__title">{title}</div>

        {img && <img src={img} className="award-item__img" alt="" />}
        {awardTitle && (
          <div className="award-item__award-title">{awardTitle}</div>
        )}
      </div>

      <div className="award-item__text">{text}</div>
    </a>
  );
};

export default AwardItem;
